import {
  DeliverySettingContextData,
  DeliverySettingFragment,
} from '@choco-admin/types';
import React, { createContext, useContext, useState, ReactNode } from 'react';

const DeliverySettingContext = createContext<
  DeliverySettingContextData | undefined
>(undefined);

export const useDeliverySettingContext = (): DeliverySettingContextData => {
  const context = useContext(DeliverySettingContext);
  if (!context) {
    throw new Error(
      'useDeliverySettingContext must be used within a DeliverySettingContextProvider'
    );
  }
  return context;
};

interface DeliverySettingContextProviderProps {
  children: ReactNode;
}

export const DeliverySettingContextProvider: React.FC<
  DeliverySettingContextProviderProps
> = ({ children }) => {
  const [chatDeliverySetting, setChatDeliverySetting] =
    useState<DeliverySettingFragment | null>(null);

  const updateDeliverySetting = (setting: DeliverySettingFragment) => {
    setChatDeliverySetting(setting);
  };

  const contextValue: DeliverySettingContextData = {
    chatDeliverySetting,
    updateDeliverySetting,
  };

  return (
    <DeliverySettingContext.Provider value={contextValue}>
      {children}
    </DeliverySettingContext.Provider>
  );
};
